// Máscara para campos do tipo percentual
angular.module("avlib").directive("avPercentMask", ["$log", function($log){
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, ctrl){

			var groupDigits = function(value){
				if (value == null || value == ""){
					return value;
				}else{
					if (value.length > 3){
						var currentGroup = value.substr(value.length-3);
						var nextInput = value.substr(0, value.length-3);
						return groupDigits(nextInput) + "." + currentGroup;
					}else{
						return value;
					}
				}
			};

			var formatPercent = function(value){
				if (value === null || value == ""){
					return value;
				}
				/*
				 * Garantindo que estamos trabalhando com string
				 */
				value = ""+value;

				// Removendo todos os caracteres não numéricos:
				value = value.replace(/\D/g,'');

				// Removendo zeros em excesso, do lado esquerdo do número. Não podemos eliminar todos os
				// zeros à esquerda pois alguns são parte de valores menos do que 1,00 %.
				if (value.length > 3 && value.match(/0+\d{3,}/g)){
					var nonZeroIndex = value.search(/[1-9]/g);
					value = value.substr(nonZeroIndex, value.length-nonZeroIndex);
				}

				// Acrescentando os devidos separadores, de acordo com o tamanho atual do número:
				if (value.length > 2){
					var decimalPart = value.substr(value.length-2);
					var thousandsPart = groupDigits(value.substr(0,value.length-2));
					value =  thousandsPart + "," + decimalPart;
				}else{
					if (value.length == 1){
						value = "0,0"+value;
					}else{
						value = "0,"+value;
					}
				}
				// Acrescentando o sinal de percentual
				value = value + " %";

				return value;
			};

			var percentParser = function(viewValue){
				//$log.debug("Parser: ["+viewValue+"]");
				if (viewValue == ""){
					//ctrl.$setViewValue("");
					//ctrl.$render();
					setViewWithCaret("");
					return null;
				}
				/*
				 * A entrada 0,00  indica que o valor original era 0,00 % e o usuário digitou backspace,
				 * na tentativa de apagar o valor que se encontrava na caixa. Esse é o nosso sinal para
				 * eliminar todos caracteres da caixa e atribuir nulo ao modelo.
				 */
				if (viewValue == "0,00" || viewValue == "0,0 %"){
					//ctrl.$setViewValue("");
					//ctrl.$render();
					setViewWithCaret("");
					return null;
				}
				/*
				 * Casos em que o usuário digita backspace com o cursor exatamente à direita ou esquerda do % 
				 */
				// O [^\s] nas últimas expressões regulares evita que entre nesse caso a chamada recursiva feita
				// no tratamento abaixo, dos casos em que o usuário digita algum número ao lado do %
				if (viewValue.match(/\d\s$/) || (viewValue.match(/\d$/) && !viewValue.match(/\s%\d$/)) || viewValue.match(/[^\s]\d%$/)){
					//$log.debug("Detectada necessidade de eliminar um dígito menos significativo");
					var numberOnly = viewValue.replace(/\D/g,'');
					numberOnly = numberOnly.substr(0, numberOnly.length-1);
					//$log.debug(numberOnly);
					var modelValue = numberOnly;
					if (viewValue.indexOf(",") > -1){
						modelValue = numberOnly.substr(0, numberOnly.length-2)+"."+numberOnly.substr(numberOnly.length-2, numberOnly.length);
						var formattedPercent = formatPercent(modelValue);
						//ctrl.$setViewValue(formattedPercent);
						//ctrl.$render();
						setViewWithCaret(formattedPercent);
						var parsed = parseFloat(modelValue);
						return parsed/100;
					}
				}
				/*
				 * Casos em que o usuário digita um número com o cursor exatamente à direita ou esquerda do % 
				 */
				if (viewValue.match(/%\d$/)){
					var newDigit = viewValue.substr(viewValue.length-1, 1);
					var previousNumber = viewValue.substr(0, viewValue.length-3);
					var correctedViewValue = previousNumber+newDigit+" %";
					return percentParser(correctedViewValue);
				}
				if (viewValue.match(/\s\d%$/)){
					var newDigit = viewValue.substr(viewValue.length-2, 1);
					var previousNumber = viewValue.substr(0, viewValue.length-3);
					var correctedViewValue = previousNumber+newDigit+" %";
					return percentParser(correctedViewValue);
				}
				/*
				 * Se não existe nenhum valor no campo e o usuário digita um caracter não-numérico, mantemos
				 * o campo nulo.
				 */
				if (!viewValue.endsWith("%") && !viewValue.match(/\d/g)){
					//ctrl.$setViewValue("");
					//ctrl.$render();
					setViewWithCaret("");
					return null;
				}

				var formattedPercent = formatPercent(viewValue);
				//ctrl.$setViewValue(formattedPercent);
				//ctrl.$render();
				setViewWithCaret(formattedPercent);

				if (formattedPercent == null){
					return null;
				}else{
					var modelValue = formattedPercent.replace(/[^,\d]/g,'');
					modelValue = modelValue.replace(/,/g,'.');
					var parsed = parseFloat(modelValue);
					return parsed/100;
				}
			};

			var percentFormatter = function(modelValue){
				//$log.debug("Formatter: "+modelValue);
				if (modelValue === null){
					return "";
				}else{
					if (isNaN(modelValue)){
						ctrl.$modelValue = null;
						return null;
					}else{
						ctrl.$modelValue = modelValue;
						return formatPercent((modelValue*100).toFixed(2));
					}
				}
			};

			/*
			 * Tentativa fracassada de manter a posição do cursos no mesmo local no texto. Precisa
			 * ser melhor explorado.
			 */
			var setViewWithCaret = function(viewValue){
				//var caretPosition = element[0].selectionStart;
				ctrl.$setViewValue(viewValue);
				ctrl.$render();
				//element[0].selectionStart = element[0].selectionEnd = caretPosition;
			};

			ctrl.$parsers.push(percentParser);
			ctrl.$formatters.push(percentFormatter);
		}
	};
}]);
